export default "__VITE_ASSET__T$CXgwPi__"